Vue.component('ack-warranty-policies', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-warranty-policies',
    mixins: [languageMixins],
    created() {
      
    },
    mounted() {
      appLog.log('ack-warranty-policies mounted')
      this.setPageIsLoading(false)
    },
    props:{
      // dataIn: {
      //   type: Object,
      //   required: true
      // }

    },
    computed: {
      //...Vuex.mapGetters('sliders', ['slidersLists']),
      //...Vuex.mapGetters('articles', ['articlesArray']),
      isMobile(){
        return this.$parent.isMobile
      },
    },
    data() {
      return {
        pageId: 'warranty-policies-page',
        policyGroups: [
            {
              title: '3D Printers',
              policies: [
                {
                  title: 'SOL Plus Warranty',
                  image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_SOL_Plus.png?v=1707216660',
                  url: 'https://go.ackuretta.com/sol-plus/warranty'
                },
                {
                  title: 'SOL Warranty',
                  image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_SOL_42f22b61-0cef-4347-8c7e-dc4068919803.png?v=1699251755',
                  url: 'https://go.ackuretta.com/SOL/warranty'
                },
                {
                  title: 'DENTIQ Warranty',
                  image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_DENTIQ.png?v=1697949353',
                  url: 'https://go.ackuretta.com/DENTIQ/warranty'
                },
              ]
            },
            {
                title: 'Post-Processing',
                policies: [
                  {
                    title: 'CLEANI Warranty',
                    image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/V4_Dual_Tanks.png?v=1707216660',
                    url: 'https://go.ackuretta.com/CLEANI/warranty'
                  },
                  {
                    title: 'CURIE Plus Warranty',
                    image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/CURIE_Plus_01.png?v=1693879714',
                    url: 'https://go.ackuretta.com/curie-plus/warranty'
                  },
                  {
                    title: 'NFinity Warranty',
                    image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/NFinity_2.png?v=1715586930',
                    url: 'https://go.ackuretta.com/nfinity/warranty'
                  },
                  {
                    title: 'CURIE Warranty',
                    image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/CURIE_1_1.png?v=1681258701',
                    url: 'https://go.ackuretta.com/CURIE/warranty'
                  },
                  {
                    title: 'UV Box Warranty',
                    image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/products/UV-BOX.png?v=1703663929',
                    url: 'https://go.ackuretta.com/uv-box/warranty'
                  },
                ]
            },
            {
                title: 'Ackuretta Concierge',
                policies: [
                  {
                    title: 'Concierge Services Policy',
                    image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Concierge_Service_logo_Color-2.png?v=1681258921',
                    url: 'https://go.ackuretta.com/concierge-service/warranty'
                  },
                  {
                    title: 'Concierge World Policy',
                    image: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Concierge_World_logo_Color.png?v=1693994879',
                    url: 'https://go.ackuretta.com/concierge-world/warranty'
                  },
                ]
              },
          ]
      }
    },
    methods: {
      ...Vuex.mapActions(['setPageIsLoading'])
      //...Vuex.mapActions('sliders', ['getSlideList'])




    },
    beforeDestroy() {

    },
    watch: {

      data1: {
        handler() {



        },
        deep: false
      }
    }
  })